var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',{attrs:{"src":_vm.fvalue,"size":_vm.size,"shape":_vm.shape,"alt":_vm.alt,"fit":_vm.fit}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }